module.exports = __webpack_public_path__ + "img/play.555c7ad0.svg";